import { CLINICIAN_TYPE } from "@src/constants";
import type { ClinicianType } from "@src/constants/filter-constants";

/**
 * Determines if a clinician type represents a Prescriber.
 * Centralizes this check to reduce drift across API and service layers.
 */
export const isPrescriberClinicianType = (clinicianType: ClinicianType | undefined): boolean => {
  return clinicianType === CLINICIAN_TYPE.PRESCRIBER;
};

/**
 * Resolves therapy types based on clinician type.
 * For Prescribers, always returns undefined (they don't have therapy types).
 * For Therapists, returns provided value or defaults to "Individual".
 * Used by both provider-search.service and /api/v1/provider-search.
 */
export const resolveTherapyTypesForRequest = (
  clinicianType: ClinicianType | undefined,
  providedTherapyTypes?: string,
): string | undefined => {
  if (isPrescriberClinicianType(clinicianType)) {
    return undefined;
  }
  return providedTherapyTypes || "Individual";
};
